import { useState } from 'react';

import { OrdersDetailResponse, OrderCalculateRefundResponse, OrderlineStatus } from '@/apis';
import { ORDER_TEMPLATE } from '@/utils';

import { useDialog } from './useDialog';
import { useToast } from './useToast';

const redirectToValidURL = (url: string) => {
  // 정규 표현식을 사용하여 URL이 "http://" 또는 "https://"로 시작하는지 확인
  const urlPattern = /^https?:\/\//i;

  if (!urlPattern.test(url)) {
    // URL에 "http://"를 추가하여 새 URL을 생성
    const newURL = 'http://' + url;
    // 현재 페이지를 새 URL로 리다이렉트
    window.location.href = newURL;
  } else {
    window.location.href = url;
  }
};

export const useOrder = (order: OrdersDetailResponse) => {
  const toastOn = useToast();
  const [dialogOn, dialogOff] = useDialog();
  const allOrderlines = order?.orders?.flatMap((orderGroup) => orderGroup.orderlines);

  const [refundInfo, setRefundInfo] = useState<OrderCalculateRefundResponse>({
    is_full_cancel: false,
    cancel_data: {
      cancel_amount: 0,
      total_product_price: 0,
      current_shipping_fee: 0,
      additional_shipping_fee: 0,
      discount_price: 0,
      exclude_from_additional_shipping: false,
    },
  });
  const [refundLoading, setRefundLoading] = useState<boolean>(false);

  // 배송지 수정 버튼 노출 여부
  const showEditDeliveryBtn =
    allOrderlines &&
    !allOrderlines.every((orderline) => orderline.status === OrderlineStatus.CANCELED) &&
    !allOrderlines.some((orderline) =>
      [OrderlineStatus.PREPARING, OrderlineStatus.IN_TRANSIT, OrderlineStatus.DELIVERED].includes(
        orderline.status,
      ),
    );

  const onClickCSChannel = () => {
    if (order?.cs_channel) {
      const phonePattern = /^\d{10,14}$/;

      if (phonePattern.test(order?.cs_channel)) {
        return dialogOn({
          template: ORDER_TEMPLATE.campaign.cs(),
          confirm: {
            type: 'primary',
            text: '바로 연락하기',
            onClick: () => {
              dialogOff();
              const phoneLink = `tel:${order.cs_channel}`;
              return (window.location.href = phoneLink);
            },
          },
        });
      }

      redirectToValidURL(order?.cs_channel as string);
    } else {
      toastOn('문의 채널이 등록되어있지 않아요 😢');
    }
  };

  return {
    refundInfo,
    setRefundInfo,
    refundLoading,
    setRefundLoading,
    showEditDeliveryBtn,
    onClickCSChannel,
  };
};
